import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios, { AxiosError, AxiosRequestConfig } from 'axios';
import { IProperty } from '../../pages/Listings/Listings';
import axiosCall from '../../utils/axiosCall';
import { ListingSection } from '../../constants/ListingSection';
const apiUrl = process.env.REACT_APP_API_URL;

export interface IApiResponse {
  data: {
    co_living: IListingProperty[];
    boys_pg: IListingProperty[];
    girls_pg: IListingProperty[];
    flat: IListingProperty[];
    house: IListingProperty[];
    room: IListingProperty[];
    vila: IListingProperty[];
    // rooms: IListingProperty[]
    // house: IListingProperty[]
    // condos: IListingProperty[]
    // apartment: IListingProperty[]
    // hotel: IListingProperty[]
  };
  totalPages: number;
  currentPage: number;
  pageSizes: number;
  totalPropertyCount: number;
}

export interface IListingProperty {
  name: string;
  price: number;
  bathroomType: string;
  depositMoney: number;
  cleaningCharges: number;
  petFees: number;
  availableFrom: string;
  _id: string;
  propertyId: string;
  propertyTitle: string;
  propertyStatus: string;
  isFeaturedProperty: true;
  address: {
    street: string;
    city: string;
    state: string;
    zip: string;
    latitude: string;
    longitude: string;
    _id: string;
  };
  imagesLink: string[];
  amenities: [
    {
      name: string;
      order: number;
      icon: string;
      _id: string;
    },
  ];
  isActive: boolean;
  isFavoriteForThisUser: boolean;
  type: string;
  averageRating: number;
  withFood: string;
}

const initialState: {
  listing: IApiResponse;
  propertyListing: any;
  loading: boolean;
  isPropertyLoading: boolean;
  error: string | undefined;
  success: boolean;
  isPropertyDeleted: boolean;
  postFavPropertyLoading: boolean;
  postFavPropertyError: string | undefined;
  postFavPropertySuccess: boolean;
  deleteFavPropertyLoading: boolean;
  deleteFavPropertyError: string | undefined;
  deleteFavPropertySuccess: boolean;

  changePropertyStatusLoading: boolean;
  changePropertyStatusError: string | undefined;
  changePropertyStatusSuccess: boolean;
  section: ListingSection.Details;
} = {
  listing: {
    data: {
      co_living: [],
      boys_pg: [],
      girls_pg: [],
      flat: [],
      house: [],
      room: [],
      vila: [],
      // rooms: [],
      // house: [],
      // condos: [],
      // apartment: [],
      // hotel: []
    },
    totalPages: 1,
    currentPage: 1,
    pageSizes: 10,
    totalPropertyCount: 1,
  },
  propertyListing: [],
  loading: false,
  isPropertyLoading: false,
  error: '',
  success: false,
  isPropertyDeleted: false,
  postFavPropertyLoading: false,
  postFavPropertyError: '',
  postFavPropertySuccess: false,
  deleteFavPropertyLoading: false,
  deleteFavPropertyError: '',
  deleteFavPropertySuccess: false,
  changePropertyStatusLoading: false,
  changePropertyStatusError: '',
  changePropertyStatusSuccess: false,
  section: ListingSection.Details,
};

export const ListingSlice = createSlice({
  name: 'listing',
  initialState,
  reducers: {
    //set cerateListing state.createListing
    getListing: (state, action) => {
      const { listing, error, loading } = action.payload;
      state.listing = listing;
      state.error = error;
      state.loading = loading;
    },
    resetListingState: (state, action) => {
      // state.error = "";
      // state.loading = false;
      // state.success = false;
      state.isPropertyDeleted = false;
      state.postFavPropertyLoading = false;
      state.postFavPropertyError = '';
      state.postFavPropertySuccess = false;
      state.deleteFavPropertyLoading = false;
      state.deleteFavPropertyError = '';
      state.deleteFavPropertySuccess = false;
    },
    setSection: (state, data: any) => {
      state.section = data;
    },
    setIsFavourite: (state, action) => {
      const { id } = action.payload;

      // if (state.postFavPropertySuccess) {
      // state.listing.data?.rooms?.forEach((element, index) => {
      //   if (element._id === id) {
      //     state.listing.data.rooms[index].isFavoriteForThisUser = true;
      //   }
      // })
      // state.listing.data?.apartment?.forEach((element, index) => {
      //   if (element._id === id) {
      //     state.listing.data.apartment[index].isFavoriteForThisUser = true;
      //   }
      // })
      // state.listing.data?.condos?.forEach((element, index) => {
      //   if (element._id === id) {
      //     state.listing.data.condos[index].isFavoriteForThisUser = true;
      //   }
      // })
      // state.listing.data?.house?.forEach((element, index) => {
      //   if (element._id === id) {
      //     state.listing.data.house[index].isFavoriteForThisUser = true;
      //   }
      // })
      // state.listing.data?.hotel?.forEach((element, index) => {
      //   if (element._id === id) {
      //     state.listing.data.hotel[index].isFavoriteForThisUser = true;
      //   }
      // })
      state.listing.data?.co_living?.forEach((element, index) => {
        if (element._id === id) {
          state.listing.data.co_living[index].isFavoriteForThisUser = true;
        }
      });
      state.listing.data?.boys_pg?.forEach((element, index) => {
        if (element._id === id) {
          state.listing.data.boys_pg[index].isFavoriteForThisUser = true;
        }
      });
      state.listing.data?.girls_pg?.forEach((element, index) => {
        if (element._id === id) {
          state.listing.data.girls_pg[index].isFavoriteForThisUser = true;
        }
      });
      state.listing.data?.flat?.forEach((element, index) => {
        if (element._id === id) {
          state.listing.data.flat[index].isFavoriteForThisUser = true;
        }
      });
      state.listing.data?.house?.forEach((element, index) => {
        if (element._id === id) {
          state.listing.data.house[index].isFavoriteForThisUser = true;
        }
      });
      state.listing.data?.room?.forEach((element, index) => {
        if (element._id === id) {
          state.listing.data.room[index].isFavoriteForThisUser = true;
        }
      });
      state.listing.data?.vila?.forEach((element, index) => {
        if (element._id === id) {
          state.listing.data.vila[index].isFavoriteForThisUser = true;
        }
      });
      state.isPropertyDeleted = false;
      state.postFavPropertyLoading = false;
      state.postFavPropertyError = '';
      state.postFavPropertySuccess = false;
      state.deleteFavPropertyLoading = false;
      state.deleteFavPropertyError = '';
      state.deleteFavPropertySuccess = false;
      // }
    },
    setIsNotFavourite: (state, action) => {
      const { id } = action.payload;
      // if (state.deleteFavPropertySuccess) {
      state.listing.data?.co_living?.forEach((element, index) => {
        if (element._id === id) {
          state.listing.data.co_living[index].isFavoriteForThisUser = false;
        }
      });
      state.listing.data?.boys_pg?.forEach((element, index) => {
        if (element._id === id) {
          state.listing.data.boys_pg[index].isFavoriteForThisUser = false;
        }
      });
      state.listing.data?.girls_pg?.forEach((element, index) => {
        if (element._id === id) {
          state.listing.data.girls_pg[index].isFavoriteForThisUser = false;
        }
      });
      state.listing.data?.flat?.forEach((element, index) => {
        if (element._id === id) {
          state.listing.data.flat[index].isFavoriteForThisUser = false;
        }
      });
      state.listing.data?.house?.forEach((element, index) => {
        if (element._id === id) {
          state.listing.data.house[index].isFavoriteForThisUser = false;
        }
      });
      state.listing.data?.room?.forEach((element, index) => {
        if (element._id === id) {
          state.listing.data.room[index].isFavoriteForThisUser = false;
        }
      });
      state.listing.data?.vila?.forEach((element, index) => {
        if (element._id === id) {
          state.listing.data.vila[index].isFavoriteForThisUser = false;
        }
      });
      // state.listing.data?.rooms?.forEach((element, index) => {
      //   if (element._id === id) {
      //     state.listing.data.rooms[index].isFavoriteForThisUser = false;
      //   }
      // })
      // state.listing.data?.apartment?.forEach((element, index) => {
      //   if (element._id === id) {
      //     state.listing.data.apartment[index].isFavoriteForThisUser = false;
      //   }
      // })
      // state.listing.data?.condos?.forEach((element, index) => {
      //   if (element._id === id) {
      //     state.listing.data.condos[index].isFavoriteForThisUser = false;
      //   }
      // })
      // state.listing.data?.house?.forEach((element, index) => {
      //   if (element._id === id) {
      //     state.listing.data.house[index].isFavoriteForThisUser = false;
      //   }
      // })
      // state.listing.data?.hotel?.forEach((element, index) => {
      //   if (element._id === id) {
      //     state.listing.data.hotel[index].isFavoriteForThisUser = false;
      //   }
      // })
      state.isPropertyDeleted = false;
      state.postFavPropertyLoading = false;
      state.postFavPropertyError = '';
      state.postFavPropertySuccess = false;
      state.deleteFavPropertyLoading = false;
      state.deleteFavPropertyError = '';
      state.deleteFavPropertySuccess = false;
      // }
    },
    resetFetchListingState: (state) => {
      state.success = false;
      state.error = '';
    },
    resetListingToInitalState: (state) => {
      state.listing = initialState.listing;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchListing.pending, (state) => {
      state.loading = true;
      state.error = '';
    });
    builder.addCase(fetchListing.fulfilled, (state, action) => {
      state.loading = false;
      state.success = true;
      state.listing = {
        ...action.payload,
        data: {
          co_living: [
            ...state.listing.data.co_living,
            ...action.payload.data.co_living,
          ],
          boys_pg: [
            ...state.listing.data.boys_pg,
            ...action.payload.data.boys_pg,
          ],
          girls_pg: [
            ...state.listing.data.girls_pg,
            ...action.payload.data.girls_pg,
          ],
          flat: [...state.listing.data.flat, ...action.payload.data.flat],
          house: [...state.listing.data.house, ...action.payload.data.house],
          room: [...state.listing.data.room, ...action.payload.data.room],
          vila: [...state.listing.data.vila, ...action.payload.data.vila],
        },
      };
    });
    builder.addCase(fetchListing.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
    builder.addCase(fetchSellListing.pending, (state) => {
      state.loading = true;
      state.error = '';
    });
    builder.addCase(fetchSellListing.fulfilled, (state, action) => {
      state.loading = false;
      state.success = true;
      state.listing = {
        ...action.payload,
        data: {
          flat: [...state.listing.data.flat, ...action.payload.data.flat],
          house: [...state.listing.data.house, ...action.payload.data.house],
          vila: [...state.listing.data.vila, ...action.payload.data.vila],
        },
      };
    });
    builder.addCase(fetchSellListing.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
    builder.addCase(fetchPropertiesByUser.pending, (state) => {
      state.isPropertyLoading = true;
    });
    builder.addCase(fetchPropertiesByUser.fulfilled, (state, action) => {
      state.isPropertyLoading = false;
      state.propertyListing = action.payload;
    });
    builder.addCase(fetchPropertiesByUser.rejected, (state, action) => {
      state.isPropertyLoading = false;
      state.error = action.error.message;
    });
    builder.addCase(deletePropertiesById.pending, (state) => {
      state.isPropertyLoading = true;
    });
    builder.addCase(deletePropertiesById.fulfilled, (state, action) => {
      state.isPropertyLoading = false;
      state.isPropertyDeleted = true;
    });
    builder.addCase(deletePropertiesById.rejected, (state, action) => {
      state.isPropertyLoading = false;
      state.error = action.error.message;
    });
    builder.addCase(postFavProperty.pending, (state, action) => {
      state.postFavPropertyLoading = true;
      state.postFavPropertyError = '';
      state.postFavPropertySuccess = false;
    });
    builder.addCase(postFavProperty.fulfilled, (state, action) => {
      state.postFavPropertyLoading = false;
      state.postFavPropertySuccess = true;
      state.postFavPropertyError = '';
    });
    builder.addCase(postFavProperty.rejected, (state, action) => {
      state.postFavPropertyLoading = false;
      state.postFavPropertyError = action.error.message;
      state.postFavPropertySuccess = false;
    });
    builder.addCase(deleteFavProperty.pending, (state, action) => {
      state.deleteFavPropertyLoading = true;
      state.deleteFavPropertyError = '';
      state.deleteFavPropertySuccess = false;
    });
    builder.addCase(deleteFavProperty.fulfilled, (state, action) => {
      state.deleteFavPropertyLoading = false;
      state.deleteFavPropertySuccess = true;
      state.deleteFavPropertyError = '';
    });
    builder.addCase(deleteFavProperty.rejected, (state, action) => {
      state.deleteFavPropertyLoading = false;
      state.deleteFavPropertyError = action.error.message;
      state.deleteFavPropertySuccess = false;
    });

    builder.addCase(changePropertyStatus.pending, (state, action) => {
      state.changePropertyStatusLoading = true;
      state.changePropertyStatusError = '';
      state.changePropertyStatusSuccess = false;
    });
    builder.addCase(changePropertyStatus.fulfilled, (state, action) => {
      state.changePropertyStatusLoading = false;
      state.changePropertyStatusSuccess = true;
      state.changePropertyStatusError = '';
    });
    builder.addCase(changePropertyStatus.rejected, (state, action) => {
      state.changePropertyStatusLoading = false;
      state.changePropertyStatusError = action.error.message;
      state.changePropertyStatusSuccess = false;
    });

    builder.addCase(changeSellPropertyStatus.pending, (state, action) => {
      state.changePropertyStatusLoading = true;
      state.changePropertyStatusError = '';
      state.changePropertyStatusSuccess = false;
    });
    builder.addCase(changeSellPropertyStatus.fulfilled, (state, action) => {
      state.changePropertyStatusLoading = false;
      state.changePropertyStatusSuccess = true;
      state.changePropertyStatusError = '';
    });
    builder.addCase(changeSellPropertyStatus.rejected, (state, action) => {
      state.changePropertyStatusLoading = false;
      state.changePropertyStatusError = action.error.message;
      state.changePropertyStatusSuccess = false;
    });
  },
});

export const {
  getListing,
  setSection,
  resetListingState,
  resetListingToInitalState,
  setIsFavourite,
  setIsNotFavourite,
  resetFetchListingState,
} = ListingSlice.actions;

export default ListingSlice.reducer;

export const listingState = (state: any) => state.listing.listing;

export const fetchListing = createAsyncThunk<any, any>(
  'fetchCreateListing',
  async (args: { body: any }) => {
    const response = await axiosCall.post('/properties/getAll', args.body);
    return response?.data;
  }
);

export const fetchSellListing = createAsyncThunk<any, any>(
  'fetchSellListing',
  async (args: { body: any }) => {
    const response = await axiosCall.post('/sell-property/getAll', args.body);
    return response?.data;
  }
);

export const fetchPropertiesByUser = createAsyncThunk<any, any>(
  'fetchPropertiesByUser',
  async ({
    userId,
    pageNumber,
    pageLimit,
    text,
    status,
    isActive,
    propertyType,
    dealType,
  }) => {
    try {
      const data = {
        UserID: userId,
        pageNo: pageNumber,
        pageSize: pageLimit,
        text,
        status,
        isActive,
        propertyType,
        dealType,
      };
      const response = await axiosCall.post(
        '/properties/getPropertiesbyUserId',
        data
      );
      return response?.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError;
        if (axiosError.response) {
          const errorMessage = axiosError.response.data;
          return errorMessage;
        } else {
          console.error('Error calling backend API:', axiosError.message);
          return Promise.reject(axiosError.message);
        }
      } else {
        console.error('Error calling backend API:', error);
        return Promise.reject(error);
      }
    }
  }
);

export const deletePropertiesById = createAsyncThunk<any, any>(
  'deletePropertiesById',
  async (propertyId) => {
    try {
      const response = await axiosCall.delete(
        '/properties/delete/' + propertyId
      );
      return response?.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError;
        if (axiosError.response) {
          const errorMessage = axiosError.response.data;
          return errorMessage;
        } else {
          console.error('Error calling backend API:', axiosError.message);
          return Promise.reject(axiosError.message);
        }
      } else {
        console.error('Error calling backend API:', error);
        return Promise.reject(error);
      }
    }
  }
);

export const deleteSellPropertiesById = createAsyncThunk<any, any>(
  'deleteSellPropertiesById',
  async (propertyId) => {
    try {
      const response = await axiosCall.delete(
        '/sell-property/delete/' + propertyId
      );
      return response?.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError;
        if (axiosError.response) {
          const errorMessage = axiosError.response.data;
          return errorMessage;
        } else {
          console.error('Error calling backend API:', axiosError.message);
          return Promise.reject(axiosError.message);
        }
      } else {
        console.error('Error calling backend API:', error);
        return Promise.reject(error);
      }
    }
  }
);

export const postFavProperty = createAsyncThunk<any, any>(
  'postFavProperty',
  async (arg: { body: any }) => {
    try {
      const response = await axiosCall.post(
        '/favorites/creatFavorite',
        arg.body
      );
      return response?.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError;
        if (axiosError.response) {
          const errorMessage = axiosError.response.data;
          return errorMessage;
        } else {
          console.error('Error calling backend API:', axiosError.message);
          return Promise.reject(axiosError.message);
        }
      } else {
        console.error('Error calling backend API:', error);
        return Promise.reject(error);
      }
    }
  }
);

export const deleteFavProperty = createAsyncThunk(
  'deleteFavProperty',
  async (arg: { body: any }) => {
    try {
      const response = await axiosCall.delete(
        // '/favorites/deleteFavorite/'+ arg.body.propertie_id
        `/favorites/deleteFavorite/${arg.body.propertie_id}`
      );
      return response?.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError;
        if (axiosError.response) {
          const errorMessage = axiosError.response.data;
          return errorMessage;
        } else {
          console.error('Error calling backend API:', axiosError.message);
          return Promise.reject(axiosError.message);
        }
      } else {
        console.error('Error calling backend API:', error);
        return Promise.reject(error);
      }
    }
  }
);

export const changePropertyStatus = createAsyncThunk(
  'changePropertyStatus',
  async (arg: { body: any }, { rejectWithValue }) => {
    try {
      const response = await axiosCall.post(
        '/properties/changePropertyStatus',
        arg.body
      );
      return response?.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError;
        if (axios.isAxiosError(error) && error.response) {
          return rejectWithValue({
            status: error.response.status,
            data: error.response.data,
          });
        }
        return rejectWithValue(axiosError.message);
      } else {
        return rejectWithValue('Unexpected error occurred');
      }
    }
  }
);

export const changeSellPropertyStatus = createAsyncThunk(
  'changeSellPropertyStatus',
  async (arg: { body: any }, { rejectWithValue }) => {
    try {
      const response = await axiosCall.post(
        '/sell-property/changePropertyStatus',
        arg.body
      );
      return response?.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError;
        if (axios.isAxiosError(error) && error.response) {
          return rejectWithValue({
            status: error.response.status,
            data: error.response.data,
          });
        }
        return rejectWithValue(axiosError.message);
      } else {
        return rejectWithValue('Unexpected error occurred');
      }
    }
  }
);
